<template>
  <div>
    <template v-if="$route.name === 'EXSBPaymentsMadeUpdate'">
      <b-row>
        <b-col>
          <button v-if="prevRoute.name !== 'EXSBPaymentsMadeList'" @click="$router.go(-1)" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.goBack')}}</button>
          <router-link v-else :to="{ name: 'EXSBPaymentsMadeList' }" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading">
        <b-col>
          <b-card>
            <h6 class="card-title">{{$t('routes.EXSBPaymentsMadeShow')}}</h6>
            <b-card-body>
              <b-row class="pl-3 pr-3" v-if="!retrieved.idBankPayment">
                <b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.list.value') }}:</b> {{retrieved.value}} {{$t('currency')}}</span>
                </b-col>
                <b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.edit.paymentDate') }}:</b> {{$moment(retrieved.paymentDate).format('YYYY-MM-DD')}}</span>
                </b-col>
                <b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.edit.description') }}:</b> {{ retrieved.description }}</span>
                </b-col>
              </b-row>
              <b-row class="pl-3 pr-3" v-if="retrieved.idBankPayment">
                <b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.edit.value') }}:</b> {{retrieved.idBankPayment.value}} {{$t('currency')}}</span><br>
                  <span v-if="allReletedValuesTotal > 0"><b>{{ $t('views.exsbpaymentsmade.edit.valueTotal') }}:</b> {{ allReletedValuesTotal }} {{$t('currency')}}</span>
                </b-col>
                <b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.edit.account') }}:</b> {{retrieved.idBankPayment.fromAccount}}</span>
                </b-col>
                <b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.edit.paymentDate') }}:</b> {{$moment(retrieved.idBankPayment.paymentDate).format('YYYY-MM-DD')}}</span>
                </b-col>
              </b-row>
              <b-row class="pl-3 pr-3" v-if="retrieved.idBankPayment">
                <b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.edit.payer') }}:</b> {{retrieved.idBankPayment.payer}}</span>
                </b-col>
                <b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.edit.description') }}:</b> {{retrieved.idBankPayment.description}}</span>
                </b-col><b-col>
                  <span><b>{{ $t('views.exsbpaymentsmade.edit.operationType') }}:</b> {{retrieved.idBankPayment.operationType}}</span>
                </b-col>
              </b-row>
              <b-row class="pl-3 pr-3" v-if="retrieved.idAgreement !== null && retrieved.relatedPayments !== undefined">
                <b-col>
                  <span class="text-danger"><b><i class="far fa-exclamation"></i> {{retrieved.relatedPayments}}</b></span>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="ml-2" v-if="displaySwitch">
        <b-col>
          <b-form-group>
            <b-form-radio-group buttons button-variant="outline-primary" v-model="data.type">
              <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.exsbpaymentsmade.edit.types.toAgreement')}}</b-form-radio>
              <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.exsbpaymentsmade.edit.types.toInvoice')}}</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="originalData && data.type === 1">
          <PaymentMadeToInvoice :paymentMade="originalData" :cancelButton="cancelButton" :fetchData="() => cancelButton()"></PaymentMadeToInvoice>
        </b-col>
        <b-col v-else-if="originalData && data.type === 0">
          <PaymentMadeToAgreement :contentLoading="isLoading" :paymentMade="originalData" :idAgreementOptions="agreementOptions" :cancelButton="cancelButton" :fetchData="() => cancelButton()"></PaymentMadeToAgreement>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles'
import PaymentMadeToInvoice from '@/components/Dashboard/Views/BusinessBundle/exsbpaymentsmade/components/PaymentMadeToInvoice'
import PaymentMadeToAgreement from '@/components/Dashboard/Views/BusinessBundle/exsbpaymentsmade/components/PaymentMadeToAgreement'

export default {
  name: 'Update',
  components: {
    PaymentMadeToAgreement,
    PaymentMadeToInvoice
  },
  data () {
    return {
      prevRoute: {},
      displaySwitch: true,
      originalData: null,
      allReletedValuesTotal: 0,
      data: {
        type: 1
      },
      item: {
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  created () {
    this.retrieve(this.id)
    this.fetchAgreementOptions()
  },
  watch: {
    updated (val) {
      if (val) this.$router.push({ name: 'EXSBPaymentsMadeShow', params: { id: this.item['@id'] } })
    },
    retrieved (val) {
      this.item = JSON.parse(JSON.stringify(val))
      if (this.item.idEXSBInvoice) {
        this.item.idEXSBInvoice = this.item.idEXSBInvoice['@id']
      } else {
        this.item.idEXSBInvoice = null
      }
      // if (this.item.idAgreement) {
      //   this.item.idAgreement = this.item.idAgreement['@id']
      // } else {
      //   this.item.idAgreement = null
      // }
      if (this.item.idEXSBInvoice || this.item.idAgreement) {
        this.displaySwitch = false
      }
      this.data.type = this.item.type
      if (!this.item.idEXSBInvoice && !this.item.idAgreement) {
        this.data.type = 1
      }
      this.item.relatedPaymentsDiff = parseInt(this.item.relatedPaymentsDiff)
      if (this.item.relatedPaymentsDiff > 0) {
        this.allReletedValuesTotal = this.item.relatedPaymentsDiff + parseInt(this.item.value)
      }
      this.originalData = JSON.parse(JSON.stringify(this.item))
    }
  },
  computed: {
    initialValues () {
      return this.item
    },
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      updated: 'exsbpaymentsmade/update/updated',
      retrieved: 'exsbpaymentsmade/show/retrieved',
      isLoading: 'exsbpaymentsmade/show/isLoading',
      agreementOptions: 'exsbpaymentsmade/list/agreementOptions'
    })
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBPaymentsMadeUpdate')
  },
  methods: {
    ...mapActions({
      retrieve: 'exsbpaymentsmade/show/retrieve',
      fetchAgreementOptions: 'exsbpaymentsmade/list/fetchAgreementOptions'
    }),
    cancelButton () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
